var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17967_30804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 12.8332C3.77858 12.8332 1.16699 10.2216 1.16699 6.99984C1.16699 3.77809 3.77858 1.1665 7.00033 1.1665C10.2221 1.1665 12.8337 3.77809 12.8337 6.99984C12.8337 10.2216 10.2221 12.8332 7.00033 12.8332ZM7.00033 11.6665C8.238 11.6665 9.42499 11.1748 10.3002 10.2997C11.1753 9.4245 11.667 8.23751 11.667 6.99984C11.667 5.76216 11.1753 4.57518 10.3002 3.70001C9.42499 2.82484 8.238 2.33317 7.00033 2.33317C5.76265 2.33317 4.57566 2.82484 3.70049 3.70001C2.82532 4.57518 2.33366 5.76216 2.33366 6.99984C2.33366 8.23751 2.82532 9.4245 3.70049 10.2997C4.57566 11.1748 5.76265 11.6665 7.00033 11.6665V11.6665ZM7.58366 6.99984H9.91699V8.1665H6.41699V4.08317H7.58366V6.99984Z",
    fill: "#8E35DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17967_30804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/PendingIcon.86ebe6ff74f19320fc719a2e64cdf2dc.svg";
export { ForwardRef as ReactComponent };